//кнопка вверх
$(document).ready(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() > 10) {
            $('#scroll').css('display', 'block');
        } else {
            $('#scroll').css('display', 'none');
        }
    });
    $('#toTop').click(function () {
        $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
        return false;
    });
});

if (document.getElementsByClassName('image-text-link').length > 0) {
    $('.image-text-link').magnificPopup({type: 'image'});
}


//счетчик обратного отсчета
// function getTimeRemaining(endtime) {
//   var t = Date.parse(endtime) - Date.parse(new Date());
//   var seconds = Math.floor((t / 1000) % 60);
//   var minutes = Math.floor((t / 1000 / 60) % 60);
//   var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
//   var days = Math.floor(t / (1000 * 60 * 60 * 24));
//   return {
//     'total': t,
//     'days': days,
//     'hours': hours,
//     'minutes': minutes,
//     'seconds': seconds
//   };
// }
//
// function initializeClock(id, endtime) {
//   var clock = document.getElementById(id);
//   var daysSpan = clock.querySelector('.days');
//   var hoursSpan = clock.querySelector('.hours');
//   var minutesSpan = clock.querySelector('.minutes');
//   var secondsSpan = clock.querySelector('.seconds');
//
//   function updateClock() {
//     var t = getTimeRemaining(endtime);
//
//     daysSpan.innerHTML = t.days;
//     hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
//     minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
//     secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
//
//     if (t.total <= 0) {
//       clearInterval(timeinterval);
//     }
//   }
//
//   updateClock();
//   var timeinterval = setInterval(updateClock, 1000);
// }


//слайдер текста
var deadline = "January 01 2018 00:00:00 GMT+0300"; //for Ukraine
var deadline = new Date(Date.parse(new Date()) + 15 * 24 * 60 * 60 * 1000); // for endless timer
// initializeClock('countdown', deadline);

var text_slide_cur = 0;

function showtext_slide() {
    $('#text_slide' + (text_slide_cur + 1)).addClass('active').css({opacity: 0}).animate({opacity: 1.0}, 1000);
    // $('#text_slide' + (text_slide_cur + 1)).addClass('active');
    setTimeout(hidetext_slide, 10000);
}

function hidetext_slide() {
    $('#text_slide' + (text_slide_cur + 1)).css({opacity: 1}).animate({opacity: 0}, 1000, function () {
        $(this).removeClass('active');
        showtext_slide();
    });
    text_slide_cur = (text_slide_cur + 1) % 4;
}

$(document).ready(function () {
    showtext_slide();
})


$(document).ready(function () {
    $('.phone-button').click(function (event) {
        $('.phone-button, .modal').toggleClass('active');
    });
    $('.close').click(function (event) {
        $('.modal').removeClass('active');
    });
});

$(document).ready(function () {
    $('.phone-button').click(function (event) {
        $('.phone-button, .modal-header').toggleClass('active');
    });
    $('.close').click(function (event) {
        $('.modal-header').removeClass('active');
    });
});


$('.form-button-gift').click(function () {
    var screen = $('.header-down .custom-form').offset().top - ($(window).height() / 30);
    $('html,body').animate({scrollTop: screen}, 800);
    return false;
});

// console.log($(".message-popup"));

//popup message
let num = 1;
setTimeout(function () {
    if (num < 3) {
        $(".message-popup").addClass('open');
        setTimeout(function () {
            $(".message-popup").removeClass('open');
            num++
            if (num <= 3) {
                openPopup();
            }

        }, 10000);
    }

}, 10000);

$('.message-popup .close-popup, .message-popup .wind-bg').click(function () {
    $(".message-popup").removeClass('open');
    num++
    if (num <= 3) {
        openPopup();
    }
});

function openPopup() {
    setTimeout(function () {

        $(".message-popup").addClass('open');

        if (num < 3) {
            setTimeout(function () {
                num++
                openPopup();
            }, 10000);
        }
        setTimeout(function () {
            $(".message-popup").removeClass('open');
        }, 10000);

    }, 60000);
}


$(document).ready(function () {
    $('.tour-block-slider').slick({
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        speed: 500,
        cssEase: 'ease-in-out',
        pauseOnDotsHover: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
        ],
    });
    $('.early-booking-tour-block-slider').slick({
        dots: false,
        slidesToScroll: 1,
        slidesToShow: 5,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        speed: 500,
        cssEase: 'ease-in-out',
        pauseOnDotsHover: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
        ],
    });
});


// WEBPACK FOOTER //
// ./resources/js/snippets/common.js